var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewEventIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14.275,
    viewBox: "0 0 13 14.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-calendar",
    "data-name": "Icon feather-calendar",
    transform: "translate(-3.5 -2)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5635",
    "data-name": "Path 5635",
    d: "M5.539,5h8.922A2.042,2.042,0,0,1,16.5,7.039v8.922A2.042,2.042,0,0,1,14.461,18H5.539A2.042,2.042,0,0,1,3.5,15.961V7.039A2.042,2.042,0,0,1,5.539,5Zm8.922,11.471a.51.51,0,0,0,.51-.51V7.039a.51.51,0,0,0-.51-.51H5.539a.51.51,0,0,0-.51.51v8.922a.51.51,0,0,0,.51.51Z",
    transform: "translate(0 -1.725)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5636",
    "data-name": "Path 5636",
    d: "M23.765,6.078A.765.765,0,0,1,23,5.314V2.765a.765.765,0,1,1,1.529,0V5.314A.765.765,0,0,1,23.765,6.078Z",
    transform: "translate(-11.216)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5637",
    "data-name": "Path 5637",
    d: "M11.765,6.078A.765.765,0,0,1,11,5.314V2.765a.765.765,0,1,1,1.529,0V5.314A.765.765,0,0,1,11.765,6.078Z",
    transform: "translate(-4.314)",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5638",
    "data-name": "Path 5638",
    d: "M15.735,15.529H4.265a.765.765,0,1,1,0-1.529H15.735a.765.765,0,0,1,0,1.529Z",
    transform: "translate(0 -6.902)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEventIco);
export default __webpack_public_path__ + "static/media/new-event-ico.586c7c8f.svg";
export { ForwardRef as ReactComponent };